import React, { FC } from "react";
import { ButtonProps } from "@mui/material";

import { StyledMuiButton } from "./styled";

export const StyledButton: FC<ButtonProps> = ({ children, ...props }) => (
  <StyledMuiButton {...props}>{children}</StyledMuiButton>
);
